import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('SetNewPasswordController', SetNewPasswordController);

    /** @ngInject */
    function SetNewPasswordController(
        $scope,
        $stateParams,
        $state,
        toastr,
        AuthFactory
    ) {
        var vm = this;

        vm.setNewPassword = function () {
            var data = {
                new_password1: vm.password1,
                new_password2: vm.password2,
                uid: $stateParams.uid,
                token: $stateParams.token,
            };

            AuthFactory.authPasswordResetConfirm(data)
                .success(function () {
                    toastr.success('Nowe hasło zostało ustawione.');
                    $state.go('login');
                })
                .error(function (response) {
                    for (var key in response) {
                        var value = response[key];

                        value.forEach(function (element, index, array) {
                            toastr.error(value[index]);
                        });
                    }
                });
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/partials/login/controllers/setNewPassword.controller.ts